import { ZUid } from "src/types/zUid";
import { rest } from "src/common/rest";
import { z } from "zod";
import {
  Mc2MapPoint,
  ZMc2TableResponse,
  zMc2TableResponse,
  zMc2TableRow,
  ZMc2TableRow,
} from "./Mc2EntityTypes";
import { urlMc2 } from "../../apiMc2";

export const loadMc2Table = async (
  mcEntityId: ZUid,
): Promise<ZMc2TableResponse> => {
  const resp = await rest.get(urlMc2("/table"), { params: { mcEntityId } });
  return zMc2TableResponse.parse(resp.data);
};

export const createMc2Rows = async (
  mcEntityId: ZUid,
  rows: Omit<ZMc2TableRow, "id">[],
): Promise<void> => {
  await rest.post(urlMc2("/row"), rows, { params: { mcEntityId } });
};

export const updateMc2Row = async (row: ZMc2TableRow) => {
  const resp = await rest.put(urlMc2("/row"), row);
  return zMc2TableRow.parse(resp.data);
};

export const deleteMc2Rows = async (rowIds: ZUid[]): Promise<void> => {
  await rest.delete(urlMc2(`/row`), { data: rowIds });
};

export const loadMc2BaseSizes = async (
  modelObjectId: ZUid,
  sizeLineId: ZUid,
): Promise<string[]> => {
  const resp = await rest.get(urlMc2("/mapping/sizes-list"), {
    params: { modelObjectId, sizeLineId },
  });
  return z.string().array().parse(resp.data);
};

export const loadMc2EntitySizes = async (
  mcEntityId: ZUid,
): Promise<string[]> => {
  const resp = await rest.get(urlMc2("/measurement-chart/size-by-entity"), {
    params: { mcEntityId },
  });
  return z.string().array().parse(resp.data);
};

export const updateMc2BaseSize = async (
  mcEntityId: ZUid,
  baseSize: string,
): Promise<void> => {
  await rest.put(urlMc2("/measurement-chart/base-size"), undefined, {
    params: { mcEntityId, baseSize },
  });
};

export const changeMc2RowPositions = async (rowIds: string[]) => {
  await rest.put(urlMc2("/table/new-position"), rowIds);
};

export const importMc2Rows = async (mcEntityId: ZUid, text: string) => {
  await rest.post(urlMc2("/mapping/import"), text, {
    params: { mcEntityId },
    headers: { "Content-Type": "application/json" },
  });
};

export const mapMc2Sizes = async (
  params: {
    mcEntityId: ZUid;
    sizeLineEntityID: ZUid;
  },
  points: Mc2MapPoint[],
) => {
  await rest.post(urlMc2("/mapping/map"), points, { params });
};

export const mc2Scale = async (rowIds: ZUid[]) => {
  await rest.put(urlMc2("/scale"), rowIds);
};
